/**
 * LeatherCouch — Generated by hearth-asset-pipeline
 * Furniture: 2×1 tiles
 * Generated: 2026-04-11T05:57:08.501Z
 *
 * This is a procedural isometric furniture renderer produced from a 3D model.
 * Integrates with Hearth's renderFurniture() dispatch and isoBox primitives.
 */

import { renderIsoAsset, type IsoAssetDef } from "../../render/iso-engine.js";

/** Furniture registry metadata */
export const LeatherCouch_META = {
  id: "LeatherCouch",
  name: "LeatherCouch",
  tileWidth: 2,
  tileHeight: 1,
  isoWidth: 42,
  isoDepth: 53,
  canonicalRot: 0 as const,
  interactionAnchors: [
    { type: "use_point", localWx: 1, localWy: 0, elevation: 0, faceDir: "S" },
  ],
} as const;

/** Declarative asset definition — pure data, no rendering code */
export const LeatherCouch_DEF: IsoAssetDef = {
  id: "LeatherCouch",
  name: "LeatherCouch",
  tile: [2, 1],
  geometry: { w: 64, d: 57, h: 43 },
  faces: {
    top: {
      base: "#8c5d43",
      palette: ["#8c5d43", "#91644c", "#8e624a", "#74340d", "#7b3a13"],
      metalness: 0.02,
      roughness: 0.48,
      opacity: 1.00,
      materialType: "leather",
      gradient: { stops: [[0.00, "#834d2f"], [0.33, "#86563b"], [0.67, "#855438"], [1.00, "#7e4728"]], strength: 0.063 },
      grain: { scale: 3.0, contrast: 0.300 },
      specular: { x: 0.41, y: 0.56, radius: 0.60, intensity: 0.43 },
      edgeDarken: 0.30,
      edgeHighlight: 0.40,
    },
    left: {
      base: "#632908",
      palette: ["#632908", "#5b2507", "#542106", "#4c1d05", "#6a2d09"],
      metalness: 0.00,
      roughness: 0.49,
      opacity: 1.00,
      materialType: "leather",
      gradient: { stops: [[0.00, "#5e2608"], [0.33, "#5e2809"], [0.67, "#532106"], [1.00, "#4d1e06"]], strength: 0.196 },
      grain: { scale: 6.0, contrast: 0.190, angle: 90 },
      edgeDarken: 0.30,
      edgeHighlight: 0.40,
    },
    right: {
      base: "#441904",
      palette: ["#441904", "#4b1c05", "#3c1503", "#542106", "#351202"],
      metalness: 0.00,
      roughness: 0.49,
      opacity: 1.00,
      materialType: "leather",
      gradient: { stops: [[0.00, "#3d1604"], [0.33, "#461a04"], [0.67, "#471b05"], [1.00, "#4c1d05"]], strength: 0.249 },
      grain: { scale: 7.0, contrast: 0.120 },
      specular: { x: 0.41, y: 0.79, radius: 0.46, intensity: 0.41 },
      edgeDarken: 0.30,
      edgeHighlight: 0.40,
    },
  },
  anchors: [
    { type: "use_point", wx: 1, wy: 0, elevation: 0, dir: "S" },
  ],
};

/**
 * Render LeatherCouch via the shared isometric material engine.
 * Drop-in compatible with Hearth's renderFurniture() dispatch.
 */
export function renderLeatherCouch(
  ctx: CanvasRenderingContext2D,
  screenX: number,
  screenY: number,
  direction: 0 | 1 | 2 | 3,
  state: Record<string, unknown>,
  time: number,
): void {
  renderIsoAsset(ctx, LeatherCouch_DEF, screenX, screenY, direction, state, time);
}